import { Spinner } from "@evvve/ui-kit";
import React from "react";
import style from "./style.module.scss";

export const LoaderWrap = ({ className }: { className?: string }) => (
  <div className={`${style.wrap} ${className}`}>
    <Spinner size="l" />
  </div>
);
